import React, { useEffect, useRef, useState } from "react";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sendCopy, setSendCopy] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("Sending...");

    const formData = {
      access_key: "a56bf7ab-2bb5-4132-ba62-fd36200a507f", // Your live key is plugged in here
      name: name,
      email: email,
      message: message,
      sendCopy: sendCopy,
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      
      if (result.success) {
        setStatus("Success! Your message has been sent.");
        setName("");
        setEmail("");
        setMessage("");
        setSendCopy(false);
      } else {
        setStatus("Error: " + result.message);
      }
    } catch (error) {
      setStatus("Something went wrong. Please try again.");
    }
  };

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const calculateAvailableHeight = () => {
      const headerHeight = document.querySelector("header")?.offsetHeight || 0;
      const footerHeight = document.querySelector("footer")?.offsetHeight || 0;
      const navigationHeight = document.querySelector("nav")?.offsetHeight || 0;
      return window.innerHeight - headerHeight - footerHeight - navigationHeight;
    };

    const updateContainerHeight = () => {
      if (containerRef.current) {
        containerRef.current.style.height = `${calculateAvailableHeight()}px`;
      }
    };

    updateContainerHeight();
    window.addEventListener("resize", updateContainerHeight);

    return () => {
      window.removeEventListener("resize", updateContainerHeight);
    };
  }, []);

  return (
    <div ref={containerRef} className="flex justify-center items-center bg-gray-900">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md md:max-w-xl lg:max-w-2xl">
        <h2 className="text-2xl font-bold mb-6 text-center">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block mb-2 font-bold text-gray-700">
              Name
            </label>
            <input
              type="text"
              id="name"
              className="w-full px-3 py-2 text-gray-700 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="block mb-2 font-bold text-gray-700">
              Email address
            </label>
            <input
              type="email"
              id="email"
              className="w-full px-3 py-2 text-gray-700 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="message" className="block mb-2 font-bold text-gray-700">
              Message
            </label>
            <textarea
              id="message"
              rows={4}
              className="w-full px-3 py-2 text-gray-700 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
          </div>
          <div className="mb-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={sendCopy}
                onChange={(e) => setSendCopy(e.target.checked)}
                className="form-checkbox h-5 w-5 text-blue-600"
              />
              <span className="ml-2 text-gray-700">Send me a copy of this message</span>
            </label>
          </div>
          <button
            type="submit"
            className="w-full bg-red-600 text-white font-bold py-2 px-4 rounded hover:bg-red-700 transition duration-300"
            disabled={status === "Sending..."}
          >
            {status === "Sending..." ? "SENDING..." : "SEND"}
          </button>
          
          {status && status !== "Sending..." && (
            <div className={`mt-4 text-center font-semibold ${status.includes("Success") ? "text-green-600" : "text-red-600"}`}>
              {status}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export { ContactPage };